import React, { lazy } from 'react';
import { Switch } from 'react-router';
import Router from '../components/Router';
import { Home } from '../modules/home';
import ScheduleForm from '../modules/schedule/ScheduleForm';

const Schedule = lazy(() => import('../modules/schedule'));
const PaymentMethod = lazy(() => import('../modules/payment_method/PaymentMethod'));
const User = lazy(() => import('../modules/user/User'));
const UserDetail = lazy(() => import('../modules/user/UserDetail'));
const Menu = lazy(() => import('../modules/menu'));
const MenuForm = lazy(() => import('../modules/menu/MenuForm'));
const Package = lazy(() => import('../modules/package'));
const PackageForm = lazy(() => import('../modules/package/PackageForm'));
const Order = lazy(() => import('../modules/order/Order'));
const Merchant = lazy(() => import('../modules/merchant/Merchant'));
const MerchantDetail = lazy(() => import('../modules/merchant/MerchantDetail'));
const MerchantProduct = lazy(() => import('../modules/merchant/MerchantProduct'));

// const Topup = lazy(() => import('./modules/topup/Topup'));
// const Refund = lazy(() => import('./modules/refund/Refund'));
// const Subscription = lazy(() => import('./modules/subscription/Subscription'));
const Admin = lazy(() => import('../modules/admin'));
const Banner = lazy(() => import('../modules/banner/Banner'));
const Login = lazy(() => import('../modules/auth/Login'));
const Sales = lazy(() => import('../modules/sales/Sales'));
const SalesDetail = lazy(() => import('../modules/sales/SalesDetail'));
const Subscription = lazy(() => import('../modules/subscription/Subscription'));
// const Statistic = lazy(() => import('./modules/statistic/Statistic'));
// const Ingredient = lazy(() => import('./modules/ingredient/Ingredient'));
// const IngredientDetail = lazy(() => import('./modules/ingredient/IngredientDetail'));
const Voucher = lazy(() => import('../modules/voucher/Voucher'));
const VoucherForm = lazy(() => import('../modules/voucher/VoucherForm'));
const VoucherDetail = lazy(() => import('../modules/voucher/VoucherDetail'));
const MapayaPayReport = lazy(() => import('../modules/report/MapayaPay'));

const Setting = lazy(() => import('../modules/setup/Setup'));
const Category = lazy(() => import('../modules/category/Category'));

const PrintOrder = lazy(() => import('../modules/order/PrintOrder'));
const PrintOrderLog = lazy(() => import('../modules/order/PrintOrderLog'));

function generateRoute(
    title,
    description,
    path,
    component,
    icon = false,
    exact = true,
    showOnNav = true,
    requireAuth = true,
) {
    return {
        requireAuth,
        exact,
        path,
        component,
        icon,
        title,
        description,
        showOnNav,
    };
}


export const routeList = [
    {
        id: 'Dashboard',
        icon: 'dashboard',
        route: generateRoute('Dashboard', 'A Quick View of What\'s Happening on Mapaya', '/', Home, 'dashboard'),
        children: [],
    },
    {
        id: 'System',
        icon: 'system_update_alt',
        children: [
            generateRoute('Function', 'function', '/functions', Setting, 'settings'),
            generateRoute('Administrator', 'We are Mapaya\'s Team', '/admins', Admin, 'supervisor_account'),
            generateRoute('Payment Method', '', '/payment-method', PaymentMethod, 'contactless'),
            generateRoute('Category', '', '/categories', Category, 'category'),
            generateRoute('Banner', '', '/banners', Banner, 'view_carousel'),
            generateRoute('Merchant', '', '/merchants', Merchant, 'storefront'),
            generateRoute('Merchant', '', '/merchants/create', Merchant, 'supervisor', true, false),
            generateRoute('', '', '/merchants/:merchantId/products/:productId', MerchantProduct, 'supervisor', false, false),
            generateRoute('', '', '/merchants/:merchantId', MerchantDetail, 'supervisor', false, false),
        ],
    },
    {
        id: 'Main Section',
        icon: 'power_setting_new',
        children: [

            generateRoute('Schedule', 'Set schedule for customer menu', '/schedules', Schedule, 'date_range'),
            generateRoute('Schedule', 'Set schedule for customer menu', '/schedules/create', ScheduleForm, 'date_range', true, false),
            generateRoute('Schedule', 'Set schedule for customer menu', '/schedules/:date', ScheduleForm, 'date_range', true, false),

            generateRoute('User', 'Registered customer', '/users', User, 'face'),
            generateRoute('Account', 'Registered customer', '/users/:id', UserDetail, 'account_circle', false, false),

            generateRoute('Menu', 'Mapaya\'s menu book', '/menus', Menu, 'book'),
            generateRoute('Menu', 'Mapaya\'s menu book', '/menus/create', MenuForm, false, true, false),
            generateRoute('Menu', 'Mapaya\'s menu book', '/menus/:id', MenuForm, false, false, false),

            generateRoute('Package', 'Mapaya\'s menu packages', '/packages', Package, 'all_inbox'),
            generateRoute('Package', 'Mapaya\'s menu packages', '/packages/create', PackageForm, false, true, false),
            generateRoute('Package', 'Mapaya\'s menu packages', '/packages/:id', PackageForm, false, false, false),

            generateRoute('Order', 'Hungry customers list', '/orders', Order, 'restaurant'),

            generateRoute('Subscription', 'Subscription Report', '/subscriptions', Subscription, 'loop'),
            generateRoute('Subscription', 'Subscription Report', '/orders/print', PrintOrder, 'loop', true, false),
            generateRoute('Subscription', 'Subscription Report', '/orders/print_logs', PrintOrderLog, 'loop', true, false),
        ],
    },
    // {
    //     id: 'Transaction',
    //     children: [
    // generateRoute('Mapaya Pay', 'Top up Mapaya Pay', '/mapaya-pay', Topup, 'account_balance_wallet'),
    // generateRoute('Refund', 'Refund Mapaya Pay', '/mapaya-pay/refund', Refund, 'account_balance_wallet',
    // true, false), generateRoute('Subscription', 'Easy order', '/subscriptions', Subscription, 'loop'),
    // generateRoute('Statistics', 'Easy order', '/statistics', Statistic, 'dollar'),
    // ],
    // },
    {
        id: 'Report',
        icon: 'show_chart',
        children: [
            generateRoute('Mapaya Pay', '', '/reports/mapaya-pay', MapayaPayReport, 'account_balance_wallet'),
            generateRoute('Sales', 'Easy order', '/sales', Sales, 'bar_chart'),
            generateRoute('Sales Detail', 'Easy order', '/sales/:id', SalesDetail, 'bar_chart', false, false),
            // generateRoute('Refund', 'Refund Mapaya Pay', '/mapaya-pay/refund', Refund, 'account_balance_wallet',
            // true, false), generateRoute('Subscription', 'Easy order', '/subscriptions', Subscription, 'loop'),
            // generateRoute('Sales', 'Easy order', '/sales', Sales, 'dollar'),
            // generateRoute('Statistics', 'Easy order', '/statistics', Statistic, 'dollar'),
        ],
    },
    // {
    //     id: 'Kitchen',
    //     children: [
    //         generateRoute('Ingredient', 'Ingredient', '/ingredients', Ingredient, 'veggie'),
    //         generateRoute('Ingredient Detail', 'Ingredient Detail', '/ingredients/:id', IngredientDetail, 'veggie',
    // false, false), ], },
    {
        id: 'Marketing',
        icon: 'work',
        children: [
            generateRoute('Voucher', 'Voucher', '/vouchers', Voucher, 'loyalty'),
            generateRoute('Add Voucher', 'Voucher', '/vouchers/create', VoucherForm, 'loyalty', true, false),
            generateRoute('Voucher Detail', 'Voucher Detail', '/vouchers/:id', VoucherDetail, 'veggie', false, false),
        ],
    },
    {
        id: 'Auth',
        hideNav: true,
        children: [
            generateRoute('Login', 'Login', '/login', Login, false, true, false, false),

        ],
    },

];


const routes = (
    <Switch>
        {routeList.map(({ children, ...parent }) => {
            if (children.length === 0) {
                const { route } = parent;

                return (
                    <Router
                        {...route}
                        key={route.path}
                    />
                );
            }
            return children.map((route) => (
                <Router
                    {...route}
                    key={route.path}
                />
            ));
        })}
    </Switch>
);

export default routes;
